import { render } from "./RegistrationPay.vue?vue&type=template&id=07cd12a4&scoped=true"
import script from "./RegistrationPay.vue?vue&type=script&lang=js"
export * from "./RegistrationPay.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=07cd12a4&scoped=true&lang=css"
import "@/assets/css/user/pages/keypad.css?vue&type=style&index=1&id=07cd12a4&scoped=true&lang=css"
import "@/assets/css/user/pages/touchbox.css?vue&type=style&index=2&id=07cd12a4&scoped=true&lang=css"
import "@/assets/css/user/pages/admin.css?vue&type=style&index=3&id=07cd12a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd12a4"]])

export default __exports__